import type { PropsWithChildren } from 'react'

import { AUDIO_DETAILS_ANCHOR } from '../../constants/anchors'

import styles from './AudioContentLayout.module.css'

// Centered below-the-fold column (nextjs `mx-auto max-w-3xl`) holding the tabs + suggestions. Carries
// the scroll anchor the hero's "details and comments" caret scrolls to.
type TAudioContentLayoutProps = PropsWithChildren

export const AudioContentLayout = ({ children }: TAudioContentLayoutProps) => (
    <div id={AUDIO_DETAILS_ANCHOR} className={styles.layout}>
        {children}
    </div>
)
